<template>
  <AppHeader>Create Log</AppHeader>

  <Loading v-if="state === 'loading'" />

  <div v-if="state === 'idle'" class="p-4">
    <div class="p-3 text-gray-600 bg-white shadow rounded-2xl">
      <div class="px-2 py-1 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Date</p>
        <input type="date" v-model="form.date" :max="today" class="w-full text-xl placeholder:text-lg" readonly/>
        <p v-if="errors.date" class="w-full mt-1 text-sm text-red-300">{{ errors.date }}</p>
      </div>

      <div class="px-2 py-1 border-2 mt-3 rounded-xl border-slate-100">
        <p class="text-gray-600">Entity Type</p>
        <input type="text" v-model="form.entity_type" class="w-full text-xl placeholder:text-lg" readonly/>
      </div>

      <div class="px-2 py-1 border-2 mt-3 rounded-xl border-slate-100">
        <p class="text-gray-600">Entity Name</p>
        <input type="text" v-model="form.entity_name" class="w-full text-xl placeholder:text-lg" placeholder="Enter Entity Name" readonly/>
      </div>

      <div class="px-2 py-1 border-2 mt-3 rounded-xl border-slate-100">
        <p class="text-gray-600">Incident Type</p>
        <select v-model="form.details.type" class="w-full text-md placeholder:text-sm bg-white">
          <option value="" disabled>-- Select Incident Type --</option>
          <option v-for="type in incidents_type" :key="type" :value="type">{{ type }}</option>
        </select>
      </div>

      <div class="px-2 py-1 border-2 mt-3 rounded-xl border-slate-100">
        <p class="text-gray-600">Incident Detail</p>
        <textarea v-model="form.details.detail" class="w-full text-xl placeholder:text-lg" placeholder="Enter incident detail"></textarea>
      </div>

      <div class="px-2 py-1 border-2 mt-3 rounded-xl border-slate-100">
        <p class="text-gray-600">Action Taken</p>
        <textarea v-model="form.details.action" class="w-full text-xl placeholder:text-lg" placeholder="Enter action taken"></textarea>
      </div>

      <div class="px-2 py-1 border-2 mt-3 rounded-xl border-slate-100">
        <p class="text-gray-600">Resolution</p>
        <textarea v-model="form.details.resolution" class="w-full text-xl placeholder:text-lg" placeholder="Enter resolution"></textarea>
      </div>

      <div class="px-2 py-1 border-2 mt-3 rounded-xl border-slate-100">
        <p class="text-gray-600">Uploads</p>
        <input type="file" multiple @change="handleFileUpload"  accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx" class="w-full text-sm"/>
        <ul v-if="form.uploads.length" class="mt-2 text-sm text-gray-600">
          <li v-for="(file, i) in form.uploads" :key="i">{{ file.name }}</li>
        </ul>
      </div>

      <div class="px-2 py-1 border-2 mt-3 rounded-xl border-slate-100">
        <p class="text-gray-600">Notes</p>
        <textarea v-model="form.notes" class="w-full text-xl placeholder:text-lg" placeholder="Enter Notes"></textarea>
      </div>
    </div>

    <div class="text-center">
      <button :disabled="state === 'loading'" class="px-3 py-2 text-sm mt-3 leading-none text-gray-600 uppercase rounded-full bg-slate-300 disabled:opacity-50" @click="submitLog">Create Log</button>
    </div>
  </div>
</template>

<script>
import mixin from "@/utils/mixin.js";
import formMixin from "@/utils/mixins/form";
import AppHeader from "@/components/common/Header.vue";
import Loading from "@/components/common/Loading.vue";

export default {
  name: "CreateEntityLog",
  mixins: [mixin, formMixin],
  components: { AppHeader, Loading },

  data() {
    return {
      state: "loading",
      today: new Date().toISOString().slice(0, 10),
      incidents_type: [],
      form: {
        date: "",
        entity_id: "",
        entity_name: "",
        entity_type: "",
        details: { type: "", detail: "", action: "", resolution: "" },
        notes: "",
        uploads: [],
      },
    };
  },

  methods: {
    getData() {
      this.state = "loading";
      const id = this.$route.params.id;

      this.request("GET", 'delivery-persons/' + id + '/entity-logs', {}, (resp) => {
        this.state = "idle";
        if (resp.success) {
          this.incidents_type = resp.data.incidents_type;
        }
      });
    },

    handleFileUpload(e) {
      this.form.uploads = Array.from(e.target.files);
    },

    submitLog() {
      const validationRules = {
        date: "required|date",
        entity_type: "required",
        entity_id: "required|numeric",
        notes: "string",
      };

      if (!this.validateForm(this.form, validationRules)) return;

      if (this.errors.uploads) {
        alert(this.errors.uploads);
        return;
      }

      this.state = "loading";

      const formData = new FormData();
      formData.append("date", this.form.date);
      formData.append("entity_type", this.form.entity_type);
      formData.append("entity_id", Number(this.form.entity_id));
      formData.append("details[type]", this.form.details.type);
      formData.append("details[detail]", this.form.details.detail);
      formData.append("details[action]", this.form.details.action);
      formData.append("details[resolution]", this.form.details.resolution);
      formData.append("notes", this.form.notes);

      if (this.form.uploads.length > 0) {
        this.form.uploads.forEach(file => formData.append("uploads[]", file));
      }

      this.request("POST", 'delivery-persons/' + this.form.entity_id + '/entity-logs', formData, (resp) => {
        this.state = "idle";
        if (resp.success) {
          alert(resp.message);
          this.form.details = { type: "", detail: "", action: "", resolution: "" };
          this.form.notes = "";
          this.form.uploads = [];
          this.$router.go(-1);
        } else {
          alert(resp.message);
        }
      });
    }
  },

  created() {
    this.form.date = this.today;
    this.form.entity_type = "DeliveryPerson";
    this.form.entity_id = this.$route.params.id;
    this.form.entity_name = this.$route.query.name;
    this.getData();
  },
};
</script>
